import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const Index = () => import('~/pages/index.vue').then(m => m.default || m)
// const Details = () => import('~/pages/details.vue').then(m => m.default || m)
// const Lists = () => import('~/pages/lists.vue').then(m => m.default || m)
// const Map = () => import('~/pages/map.vue').then(m => m.default || m)

// // import Agent from '~/pages/agent.vue'
// import Agent from '~/pages/2.0/agent.vue'
// import AgentRegister from '~/pages/agent-register.vue'
// import GuestRegister from '~/pages/guest-register.vue'
// // import AgentDetails from '~/pages/agent-details.vue'
// import AgentDetails from '~/pages/2.0/agent-details.vue'
// // import Details from '~/pages/details.vue'
// import Details from '~/pages/2.0/details.vue'
// // import Service from '~/pages/service.vue'
// import Service from '~/pages/2.0/service.vue'
// // import Lists from '~/pages/lists.vue'
// import Lists from '~/pages/2.0/lists.vue'
// import ContactUs from '~/pages/2.0/contact-us.vue'
// import Map from '~/pages/map.vue'
// // import Index from '~/pages/index.vue'
// import Index from '~/pages/2.0/index.vue'
// import Blog from '~/pages/seo-article/blog.vue'
// // import Review from '~/pages/seo-article/blog-review.vue'
// import Review from '~/pages/2.0/seo-article/blog-review.vue'
// // import Tips from '~/pages/seo-article/blog-tips.vue'
// import Tips from '~/pages/2.0/seo-article/blog-tips.vue'
// // import HomeKnowledge from '~/pages/seo-article/blog-home-knowledge.vue'
// import HomeKnowledge from '~/pages/2.0/seo-article/blog-home-knowledge.vue'
// // import Portfolio from '~/pages/portfolio.vue'
// import Portfolio from '~/pages/2.0/portfolio.vue'
// // import Coupon from '~/pages/coupon.vue'
// import CustomerContract from '~/pages/customer-contract.vue'
// import CustomerContractV2 from '~/pages/customer-contract-v2.vue'
// import PrivacyPolicy from '~/pages/2.0/privacy-policy.vue'
// import TermsAndConditions from '~/pages/2.0/terms-and-conditions.vue'

// // import CategoryHub from '~/pages/seo-article/category-hub.vue'
// import CategoryHub from '~/pages/2.0/seo-article/category-hub.vue'
// // import SamutprakanHub from '~/pages/seo-article/samut-prakan-hub.vue'
// import SamutprakanHub from '~/pages/2.0/seo-article/samut-prakan-hub.vue'
// // import Samutprakan from '~/pages/seo-article/samut-prakan.vue'
// import Samutprakan from '~/pages/2.0/seo-article/samut-prakan.vue'
// // import BangkokHub from '~/pages/seo-article/bangkok-hub.vue'
// import BangkokHub from '~/pages/2.0/seo-article/bangkok-hub.vue'
// // import Bangkok from '~/pages/seo-article/bangkok.vue'
// import Bangkok from '~/pages/2.0/seo-article/bangkok.vue'
// // import NonthaburiHub from '~/pages/seo-article/nonthaburi-hub.vue'
// import NonthaburiHub from '~/pages/2.0/seo-article/nonthaburi-hub.vue'
// // import Nonthaburi from '~/pages/seo-article/nonthaburi.vue'
// import Nonthaburi from '~/pages/2.0/seo-article/nonthaburi.vue'
// // import ChonburiHub from '~/pages/seo-article/chonburi-hub.vue'
// import ChonburiHub from '~/pages/2.0/seo-article/chonburi-hub.vue'
// // import Chonburi from '~/pages/seo-article/chonburi.vue'
// import Chonburi from '~/pages/2.0/seo-article/chonburi.vue'

// // import Article from '~/pages/seo-article/article.vue'
// import Article from '~/pages/2.0/seo-article/article.vue'

const Agent = () => import('~/pages/2.0/agent.vue').then(m => m.default || m)
const AgentRegister = () => import('~/pages/agent-register.vue').then(m => m.default || m)
const GuestRegister = () => import('~/pages/guest-register.vue').then(m => m.default || m)
const AgentDetails = () => import('~/pages/2.0/agent-details.vue').then(m => m.default || m)
const Details = () => import('~/pages/2.0/details.vue').then(m => m.default || m)
const Service = () => import('~/pages/2.0/service.vue').then(m => m.default || m)
const Lists = () => import('~/pages/2.0/lists.vue').then(m => m.default || m)
const ContactUs = () => import('~/pages/2.0/contact-us.vue').then(m => m.default || m)
const Map = () => import('~/pages/map.vue').then(m => m.default || m)
const Index = () => import('~/pages/2.0/index.vue').then(m => m.default || m)
const Blog = () => import('~/pages/seo-article/blog.vue').then(m => m.default || m)
const Review = () => import('~/pages/2.0/seo-article/blog-review.vue').then(m => m.default || m)
const Tips = () => import('~/pages/2.0/seo-article/blog-tips.vue').then(m => m.default || m)
const HomeKnowledge = () => import('~/pages/2.0/seo-article/blog-home-knowledge.vue').then(m => m.default || m)
const Portfolio = () => import('~/pages/2.0/portfolio.vue').then(m => m.default || m)
const CustomerContract = () => import('~/pages/customer-contract.vue').then(m => m.default || m)
const CustomerContractV2 = () => import('~/pages/customer-contract-v2.vue').then(m => m.default || m)
const PrivacyPolicy = () => import('~/pages/2.0/privacy-policy.vue').then(m => m.default || m)
const TermsAndConditions = () => import('~/pages/2.0/terms-and-conditions.vue').then(m => m.default || m)

const CategoryHub = () => import('~/pages/2.0/seo-article/category-hub.vue').then(m => m.default || m)
const SamutprakanHub = () => import('~/pages/2.0/seo-article/samut-prakan-hub.vue').then(m => m.default || m)
const Samutprakan = () => import('~/pages/2.0/seo-article/samut-prakan.vue').then(m => m.default || m)
const BangkokHub = () => import('~/pages/2.0/seo-article/bangkok-hub.vue').then(m => m.default || m)
const Bangkok = () => import('~/pages/2.0/seo-article/bangkok.vue').then(m => m.default || m)
const NonthaburiHub = () => import('~/pages/2.0/seo-article/nonthaburi-hub.vue').then(m => m.default || m)
const Nonthaburi = () => import('~/pages/2.0/seo-article/nonthaburi.vue').then(m => m.default || m)
const ChonburiHub = () => import('~/pages/2.0/seo-article/chonburi-hub.vue').then(m => m.default || m)
const Chonburi = () => import('~/pages/2.0/seo-article/chonburi.vue').then(m => m.default || m)

const Article = () => import('~/pages/2.0/seo-article/article.vue').then(m => m.default || m)

export function createRouter () {
	const samutPrakanCetagoryRestrict = 'single-house|single-home|singlehome|townhome|condo|shophouse'
	const samutPrakanAreaRestrict = 'srinakarin|thepharak|bang-phli|bangna-trad|phraeksa|bangpu|phra-pradaeng|phra-samut-chedi|bearing|lasalle|samrong|bang-bo|poo-chao-saming-prai|bang-sao-thong|pracha-uthit'

	const bangkokCetagoryRestrict = 'single-house|single-home|singlehome|townhome|condo|shophouse'
	const bangkokAreaRestrict = 'ratchaphruek|rama-2|ladprao|phaholyothin|ramintra|lat-krabang|saimai|onnut|ramkhamhaeng|phra-ram-nine|min-buri|suanluang|prakanong|ra-ma-three|pinklao|ratchadapisek|don-mueang|prawet'
	const nonthaburiCetagoryRestrict = 'single-house|single-home|singlehome|townhome|condo|shophouse'
	const nonthaburiAreaRestrict = 'ladpro'
	const chonburiCetagoryRestrict = 'single-house|single-home|singlehome|townhome|condo|shophouse'
	const chonburiAreaRestrict = 'ladpro'

	let router = new Router({
		mode: 'history',

		scrollBehavior: (to, from, savedPosition) => {
			if (savedPosition) {
				return savedPosition
			} else if (to.hash) {
				return {
					selector: to.hash
				}
			} else {
				return { x: 0, y: 0 }
			}
		},

		routes: [
			{
				path: '/',
				name: 'index',
				component: Index,
				alias: [
					'/index',
					'/index.html',
				]
			},
			{
				path: '/blog',
				name: 'blog',
				component: Blog,
				alias: [
					'/blog.html',
				]
			},
			{
				path: '/blog/review',
				name: 'blog-review',
				component: Review
			},
			{
				path: '/blog/tips',
				name: 'blog-tips',
				component: Tips
			},
			{
				path: '/blog/home-knowledge',
				name: 'blog-home-knowledge',
				component: HomeKnowledge
			},
			{
				path: '/service',
				name: 'service',
				component: Service,
				alias: [
					'/service.html',
				]
			},
			{
				path: '/search',
				name: 'lists',
				component: Lists,
				alias: [
					'/recommend',
					'/latest',
					'/favorites',
					'/lists',
					'/promotion',
					'/value',
					'/promising',
					'/luxury',
					'/commercial',
					'/home-condo',
					'/land'
				]
			},
			{
				path: '/map-search',
				name: 'map',
				component: Map,
				alias: [
					'/property-map-search'
				]
			},
			{
				path: '/property/:title.p.:id',
				name: 'property-detail',
				component: Details,
				alias: [
					'/property-presentation/:title.p.:id'
				]
			},
			{
				path: '/contact-us',
				name: 'contact-us',
				component: ContactUs
			},
			{
				path: '/privacy-policy',
				name: 'privacy-policy',
				component: PrivacyPolicy
			},
			{
				path: '/terms-and-conditions',
				name: 'terms-and-conditions',
				component: TermsAndConditions
			},
			{ path: '/property/:title·p·:id', redirect: '/property/:title.p.:id' },
			{ path: '/agent', name: 'agent', component: Agent },
			{ path: '/agent/register', name: 'agent-register', component: AgentRegister },
			{ path: '/agent/:id', name: 'agent-detail', component: AgentDetails },
			{ path: '/portfolio', name: 'portfolio', component: Portfolio },
			// { path: '/coupon', name: 'coupon', component: Coupon },
			{ path: '/property-contract', name: 'property-contract', component: CustomerContract },
			{
				path: '/property-contract-agent',
				name: 'property-contract-v2',
				component: CustomerContractV2,
				alias: [
					'/property-contract-customer'
				]
			},
			{ path: '/guest-register', name: 'guest-register', component: GuestRegister },

			{ path: '/singlehome', name: 'category-hub-singlehome', component: CategoryHub },
			{ path: '/townhome', name: 'category-hub-townhome', component: CategoryHub },
			{ path: '/condo', name: 'category-hub-condo', component: CategoryHub },
			{ path: '/shophouse', name: 'category-hub-shophouse', component: CategoryHub },

			{
				path: '/samut-prakan',
				name: 'samut-prakan-hub',
				component: SamutprakanHub,
				alias: [
					// '/samut-prakan/'
				]
			},
			{
				path: `/samut-prakan/:category(${samutPrakanCetagoryRestrict})/:area(${samutPrakanAreaRestrict})?`,
				name: 'samut-prakan',
				component: Samutprakan,
				// beforeEnter: (to) => {
				// 	console.log(to)
				// 	return { path: '/samut-prakan' }
				// },
			},

			{
				path: '/bangkok',
				name: 'bangkok-hub',
				component: BangkokHub,
				alias: [

				]
			},
			{
				path: `/bangkok/:category(${bangkokCetagoryRestrict})/:area(${bangkokAreaRestrict})?`,
				name: 'bangkok',
				component: Bangkok,
			},

			{
				path: '/nonthaburi',
				name: 'nonthaburi-hub',
				component: NonthaburiHub,
				alias: [

				]
			},
			{
				path: `/nonthaburi/:category(${nonthaburiCetagoryRestrict})/:area(${nonthaburiAreaRestrict})?`,
				name: 'nonthaburi',
				component: Nonthaburi,
			},

			{
				path: '/chonburi',
				name: 'chonburi-hub',
				component: ChonburiHub,
				alias: [

				]
			},
			{
				path: `/chonburi/:category(${chonburiCetagoryRestrict})/:area(${chonburiAreaRestrict})?`,
				name: 'chonburi',
				component: Chonburi,
			},

			{ path: '/article/:category/:slug', name: 'article', component: Article },
		]
	})

	return router
}
